/**
 * Base template for configurator
 */

import { ConfiguratorConfig } from '../types';
import translationInstance from '../utils/translations';
import PartialConfigs from './partialConfigs';
import PartialUpholstery from './partialUpholstery';
import PartialWood from './partialWood';

export const createPredefinedConfigsTemplate = (modelId: string): ConfiguratorConfig => {
  const t = translationInstance.t.bind(translationInstance);

  return {
    viewer: {
      modelId: modelId,
      background: {
        color: [0.91015625, 0.91015625, 0.91015625],
      },
      defaultActions: [],
    },
    configurator: {
      options: [
        PartialConfigs,
        PartialWood,
        PartialUpholstery
      ],
      queryConfig: true,
      selector: 'virtenzo-panel',
    },
  }
}